<template>
  <step
    :context="context"
    image="/images/alarm-clock.svg"
    @back="$emit('back')"
    @submit="submit"
  >
    <template #guideDescription>
      <div>
        <b>4. Promote Days and Times — </b>You can choose to reward your members
        with <b>double points or punches</b> on specific days and times.
        <div />
        <b>5. Marketing Automation to Win Back Customers — </b>incentivize lost
        members with a discount, and choose when to activate.
      </div>
    </template>
    <template #formTitle>Gifts and Special Promotions</template>
    <template #form>
      <v-form v-model="valid" ref="form">
        <!-- Promote Days -->
        <form-section
          class="promote-section"
          header="4. Promote Days and Times—Double Points/Punches"
          optional
        >
          <div class="inline">
            <div>On days</div>
            <!-- Days -->
            <v-checkbox
              v-for="day in ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']"
              :key="day"
              :label="day"
              v-model="model.promoteDaysAndTimes.days[day.toLowerCase()]"
              :rules="rules.promoteDaysAndTimes.days"
            />
          </div>
          <!-- Times -->
          <v-radio-group
            :row="!mobile"
            class="times ma-0"
            hide-details
            v-model="model.promoteDaysAndTimes.times.value"
            :rules="rules.promoteDaysAndTimes.times"
          >
            <v-radio label="All Day" value="allDay" />
            <custom-radio
              label="Specific hours"
              value="specificHours"
              v-slot="{ selected }"
              :indent="mobile"
            >
              <v-text-field
                v-model="model.promoteDaysAndTimes.times.hours.from"
                type="time"
                placeholder="5:00 PM"
                :rules="rules.promoteDaysAndTimes.timeOption(selected)"
              />-
              <v-text-field
                v-model="model.promoteDaysAndTimes.times.hours.to"
                type="time"
                class="ml-2"
                placeholder="8:00 PM"
                :rules="rules.promoteDaysAndTimes.timeOption(selected)"
              />
            </custom-radio>
          </v-radio-group>
          <!--double or points with toggle -->
          <v-radio-group
              :row="!mobile"
              class="times ma-0"
              hide-details
              v-model="model.promoteDaysAndTimes.type.value"
          >
            <div class="inline ma-0 pa-0">Promotion Type</div>
            <div>
            <v-radio label="Double Points/Punches" value="doublePointsOrPunches" />
            <custom-radio
                label="Discount"
                value="discount"
                v-slot="{ selected }"
                :indent="mobile"
            >
              <div class="inline">
                <div>Enter discount</div>
                <v-text-field
                    class="minimal"
                    :suffix="model.promoteDaysAndTimes.type.discountType ? '%' : null"
                    :prefix="model.promoteDaysAndTimes.type.discountType ? null : '$'"
                    placeholder="5"
                    v-model="model.promoteDaysAndTimes.type.discount"
                    :rules="selected? [rules.required, rules.number] : []"
                />
                <v-switch
                    class="customSwitch"
                    v-model="model.promoteDaysAndTimes.type.discountType"
                    label="toggle percentage discount"
                    hide-details
                ></v-switch>
              </div>
            </custom-radio>
            </div>
          </v-radio-group>
          <div class="hint mt-5">
            Tip: We recommend occasional email or text reminders about the
            promotion time period.
          </div>
          <v-checkbox
            v-model="model.promoteDaysAndTimes.message.enabled"
            label="Send to members promotion messages?"
          ></v-checkbox>
          <div v-if="model.promoteDaysAndTimes.message.enabled">
            <v-radio-group
              v-model="model.promoteDaysAndTimes.message.type"
              row
              class="mt-0 ml-5"
            >
              <custom-radio label="SMS" value="SMS"/>
              <custom-radio label="Email" value="Email"/>
            </v-radio-group>
            <v-textarea
                v-model="model.promoteDaysAndTimes.message.text"
                class="mx-2 mt-n7"
                rows="1"
                hint="Message"
                :placeholder="'Double Points Happy Hour! only Mondays 5 pm to 7pm'"
                persistent-hint
                :rules="[rules.required]"
              ></v-textarea>
                          <div v-if='model.promoteDaysAndTimes.message.type == "SMS"'>
              <h3>Note:</h3>
               <ul>
                 <li>
                 1 Billing SMS - Up to 129 characters (includes spaces)
                 </li>
                 <li>
                 2 Billing SMS - Up to 269 characters (includes spaces)
                 </li>
                    <li>
                  Emojis are not supported.
                   </li>
                  </ul>
            </div>
          </div>          
        </form-section>
        <!-- Win Back -->
        <form-section
          header="5. Marketing Automation—Win Back Customers"
          optional
          tooltip="Como Sense Professional allow you to create unlimited campaigns"
        >
          <div class="inline ma-0 pa-0">
            <div>Activate</div>
            <v-text-field
              v-model="model.marketingAutomation.activate"
              class="minimal"
              :suffix="model.marketingAutomation.discountType ? '%' : null"
              :prefix="model.marketingAutomation.discountType ? null : '$'"
              placeholder="5"
              :rules="[rules.number]"
            />
            <div>discount after</div>
            <v-select
              v-model="model.marketingAutomation.after"
              class="minimal-2"
              placeholder="After 60 days"
              :items="[
                'Never',
                'After 30 Days',
                'After 60 Days',
                'After 90 Days',
              ]"
            />
            <v-switch
                class="customSwitch"
                v-model="model.marketingAutomation.discountType"
                label="toggle percentage discount"
                hide-details
            ></v-switch>
          </div>
        </form-section>
        <!-- Discount Alerts -->
        <form-section class="discount-section">
          <v-checkbox
            label="Send members text alerts when they are eligible for this discount."
            v-model="model.sendDiscountAlerts"
          />
          <div v-if="model.sendDiscountAlerts">
            <v-radio-group
              v-model="model.marketingAutomation.message.type"
              row
              class="mt-0 ml-5"
            >
              <custom-radio label="SMS" value="SMS"/>
              <custom-radio label="Email" value="Email"/>
            </v-radio-group>
            <v-textarea
                v-model="model.marketingAutomation.message.text"
                class="mx-2 mt-n7"
                rows="1"
                hint="Message"
                :placeholder="'Just writing to say we miss you, come visit us and get 10$ voucher!'"
                persistent-hint
                :rules="[rules.required]"
              ></v-textarea>
            <div v-if='model.marketingAutomation.message.type == "SMS"'>
              <h3>Note:</h3>
               <ul>
                 <li>
                 1 Billing SMS - Up to 129 characters (includes spaces)
                 </li>
                 <li>
                 2 Billing SMS - Up to 269 characters (includes spaces)
                 </li>
                    <li>
                  Emojis are not supported.
                   </li>
                  </ul>
            </div>
          </div>  
        </form-section>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import FormSection from "../FormSection";
import CustomRadio from "../CustomRadio";
import displayMixin from "@/mixins/display";

export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step,
    FormSection,
    CustomRadio,
  },
  data() {
    const required = (v) => !!v || "Field is required";
    const times = {
      value: null,
      hours: {
        from: null,
        to: null,
      },
    };
    return {
      valid: false,
      rules: {
        required,
        number: (v) =>
          v == null || !isNaN(Number(v)) || "Value must be a number",
        promoteDaysAndTimes: {
          days: [
            () => {
              if(this.model.promoteDaysAndTimes.times.value!== null
                  || this.model.promoteDaysAndTimes.times.hours.from !== null
                  || this.model.promoteDaysAndTimes.times.hours.to !== null){
                return Object.values(this.model.promoteDaysAndTimes.days).filter(d => d === true).length > 0 || " ";
              }
              return true;
            },
          ],
          times: [
            (v) => {
              const daySelected = Object.keys(
                this.model.promoteDaysAndTimes.days
              )
                .map((day) => this.model.promoteDaysAndTimes.days[day])
                .find((day) => day === true);
              return !daySelected || v != null || "";
            },
          ],
          timeOption(selected) {
            if (!selected) return [];

            return [
              required,
              () => {
                const { to, from } = times.hours;
                if (to && from && from > to) {
                  return "Range must be valid";
                }
                return true;
              },
            ];
          },
        },
      },
      model: {
        promoteDaysAndTimes: {
          days: {
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            sun: false,
          },
          times,
          message: {
            enabled: false,
            type: 'SMS',
            text: null,
          },
          type: {
            value: 'doublePointsOrPunches',
            discountType : '$',
            discount : null,
          }
        },
        marketingAutomation: {
          activate: null,
          after: null,
          discountType: '$',
          message: {
            enabled: false,
            type: 'SMS',
            text: null,
          },
        },
        sendDiscountAlerts: false,
        ...this.context.submittedData,
      },
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    },
  }
};
</script>

<style lang="scss" scoped>
.promote-section {
  .times {
    top: -14px !important;
    position: relative;
    .hint {
      margin-top: 4px !important;
    }
    ::v-deep input {
      max-width: 100px;
    }
    #app.mobile & {
      top: 12px !important;
    }
  }
}
.discount-section {
  .hint {
    #app.mobile & {
      margin-top: 12px;
    }
  }
}
</style>
